/**
 * @deprecated please use @website/ui instead
 */
export * from "./accordion";
/**
 * @deprecated please use @website/ui instead
 */
export * from "./accordion.types";
